import {ErrorHandler, inject, Injectable} from '@angular/core';
import {InsightsService} from '../services/insights/insights.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  private insightsService = inject(InsightsService);

  handleError(error: Error): void {
    this.insightsService.logException(error);
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
